import { render, staticRenderFns } from "./LearnerRegistrations.vue?vue&type=template&id=22a96046&scoped=true"
import script from "./LearnerRegistrations.vue?vue&type=script&lang=js"
export * from "./LearnerRegistrations.vue?vue&type=script&lang=js"
import style0 from "./LearnerRegistrations.vue?vue&type=style&index=0&id=22a96046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a96046",
  null
  
)

export default component.exports